
export default function Services() {
  const services = [
    {
      icon: 'ri-car-washing-line',
      title: 'Interior Deep Clean',
      description:
        'Comprehensive cleaning, vacuuming, and conditioning for all interior surfaces.',
      image:
        'https://public.readdy.ai/ai/img_res/fc100d5a0cebaf8a6d3376f1a04eef1e.jpg',
    },
    {
      icon: 'ri-brush-line',
      title: 'Exterior Detailing',
      description:
        'Hand wash, clay bar treatment, polish, and protective wax for a flawless finish.',
      image:
        'https://readdy.ai/api/search-image?query=Glossy%20luxury%20car%20exterior%20with%20perfect%20paint%20shine%20and%20water%20beads%20after%20professional%20wash%20and%20wax%20in%20studio%20lighting%20simple%20clean%20background%20automotive%20detailing%20excellence&width=800&height=600&seq=service-ext-001&orientation=landscape',
    },
    {
      icon: 'ri-contrast-drop-2-line',
      title: 'Paint Correction & Enhancement',
      // Fixed the string quoting issue by using double quotes (or escaping the apostrophe) to avoid premature termination.
      description:
        "Remove swirl marks, scratches, and oxidation to restore your vehicle's original shine.",
      image:
        'https://readdy.ai/api/search-image?query=Car%20paint%20reflection%20showing%20mirror-like%20finish%20after%20professional%20paint%20correction%20and%20polishing%20with%20perfect%20gloss%20simple%20background%20automotive%20detailng%20craftsmanship&width=800&height=600&seq=service-paint-001&orientation=landscape',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Ceramic Coating',
      description:
        'Long-lasting protection with hydrophobic and scratch-resistant coating technology.',
      image:
        'https://readdy.ai/api/search-image?query=Luxury%20car%20with%20ceramic%20coating%20showing%20water%20repellent%20beading%20effect%20and%20brilliant%20shine%20in%20professional%20lighting%20simple%20background%20automotive%20protection%20technology&width=800&height=600&seq=service-ceramic-001&orientation=landscape',
    },
    {
      icon: 'ri-tools-line',
      title: 'Full Reconditioning',
      description:
        'Complete interior and exterior restoration for maximum value and appeal.',
      image:
        'https://readdy.ai/api/search-image?query=Restored%20luxury%20vehicle%20showing%20before%20and%20after%20transformation%20with%20pristine%20condition%20perfect%20paint%20and%20interior%20in%20studio%20setting%20simple%20background%20automotive%20reconditioning%20excellence&width=800&height=600&seq=service-recon-001&orientation=landscape',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Headlight Restoration',
      description:
        'Clear cloudy, oxidized headlights and restore visibility and appearance.',
      image:
        'https://readdy.ai/api/search-image?query=Car%20headlight%20close-up%20showing%20crystal%20clear%20restored%20lens%20with%20perfect%20clarity%20and%20shine%20in%20professional%20lighting%20simple%20background%20automotive%20detailing%20restoration&width=800&height=600&seq=service-headlight-001&orientation=landscape',
    },
  ];

  return (
    <section
      id="services"
      className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 bg-white"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Our Premium Services
          </h2>
          <p className="text-base sm:text-lg text-gray-700 max-w-3xl mx-auto px-4">
            From routine maintenance to complete restoration, we deliver
            professional results that protect your investment.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-full h-48 sm:h-56 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6 sm:p-8">
                <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-[#00D9FF] rounded-xl mb-4 sm:mb-6">
                  <i
                    className={`${service.icon} text-white text-xl sm:text-2xl`}
                  ></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                  {service.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
